import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as auth from "../../store/ducks/auth.duck";
import * as utils from "../../../_metronic/utils/utils";
import { actions } from "../../store/ducks/flags.duck";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Constants } from "../../utils/Constants";
import { toAbsoluteUrl } from "../../../_metronic";

const baseUrlSso = `${Constants.baseUrl}/auth-sso`;

const USER_DATA_KEYS = {
  timeZone: (data) => data.time_zone,
  acesso_pump: (data) =>
    JSON.stringify(data.user?.empresa?.emp_acesso_pump || false),
  migrando_galax: (data) =>
    JSON.stringify(!!data.user?.empresa?.emp_galax_pay_public_token),
  user_liberado_migrar: (data) =>
    JSON.stringify(data.user?.id === data.autorizado_migrar),
  migracao_analise: (data) => JSON.stringify(data.migracao_analise || false),
  id_empresa: (data) => JSON.stringify(data.user?.usu_id_empresa),
  acesso_dom: (data) =>
    JSON.stringify(data.user?.empresa?.emp_subconta_dom_completa || false),
};

const safeLocalStorageSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`Falha ao salvar ${key} no localStorage:`, e);
    return false;
  }
};

const clearPreviousSession = () => {
  const keysToRemove = [
    "authToken",
    "timeZone",
    "acesso_pump",
    "migrando_galax",
    "user_liberado_migrar",
    "migracao_analise",
    "id_empresa",
    "acesso_dom",
    "impersonation_active",
    "impersonation_session_id",
    "impersonation_expires_at",
    "impersonation_requester",
    "impersonation_approver",
    "completou_migracao",
    "pendente_documentos",
  ];

  keysToRemove.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn(`Falha ao remover ${key} do localStorage:`, e);
    }
  });
};

const storeUserData = (authData) => {
  if (!authData?.user) {
    console.warn("storeUserData: authData.user não está disponível");
    return;
  }

  Object.entries(USER_DATA_KEYS).forEach(([key, getValue]) => {
    safeLocalStorageSet(key, getValue(authData));
  });
};

const IMPERSONATION_DATA = {
  impersonation_active: () => "true",
  impersonation_session_id: (data) => data.session_id,
  impersonation_expires_at: (data) => data.expires_at,
  impersonation_requester: (data) => JSON.stringify(data.requester),
  impersonation_approver: (data) => JSON.stringify(data.approver),
};

const storeImpersonationData = (impersonation) => {
  if (!impersonation) return;

  Object.entries(IMPERSONATION_DATA).forEach(([key, getValue]) => {
    safeLocalStorageSet(key, getValue(impersonation));
  });
};

function SsoAuth(props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    authenticateWithToken();
  }, []);

  const authenticateWithToken = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (!token) {
      setError("Token de autenticação não fornecido");
      setLoading(false);
      return;
    }

    try {
      clearPreviousSession();

      const response = await axios.post(baseUrlSso, { token });

      if (!response.data?.user) {
        throw new Error("Resposta inválida do servidor");
      }

      const authData = response.data;

      utils.setStorage("authToken", authData.token, null);
      storeUserData(authData);
      storeImpersonationData(authData.impersonation);

      const hasAcessoDom =
        authData.user.empresa?.emp_subconta_dom_completa || false;
      dispatch(actions.setAcessoDom(hasAcessoDom));
      dispatch(actions.setExibirCompletarConta(0));
      dispatch(actions.setRedirecionarCompletarConta(0));

      props.login(authData);

      history.push("/");
    } catch (err) {
      console.error("Erro ao autenticar com token:", err);
      setError(
        err.response?.data?.errors?.[0] ||
          err.response?.data?.message ||
          "Erro ao autenticar. Token inválido ou expirado."
      );
      setLoading(false);
    }
  };

  const renderMessage = (
    title,
    message = null,
    titleColor = null,
    showSpinner = false
  ) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <div className="card-login">
        <div
          className="card-login-container-logo"
          style={{ textAlign: "center" }}
        >
          <img
            alt="Logo"
            src={toAbsoluteUrl("/images/new_logo.png")}
            style={{ height: "40px", marginBottom: "48px" }}
          />
        </div>
        <h3
          className="card-login-title"
          style={
            titleColor
              ? { color: titleColor, textAlign: "center" }
              : { textAlign: "center" }
          }
        >
          {title}
        </h3>
        {message && (
          <p style={{ textAlign: "center", marginTop: "24px", color: "#666" }}>
            {message}
          </p>
        )}
        {showSpinner && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (loading) {
    return renderMessage("Autenticando...", null, null, true);
  }

  if (error) {
    return renderMessage("Erro na Autenticação", error, "#f44336", false);
  }

  return null;
}

export default connect(null, auth.actions)(SsoAuth);
